<template>
    <div class="zoom">
        <div class="zoom__in" @click="zoomInHandler">
            <svg height="27" viewBox="0 0 27 27" width="27" xmlns="http://www.w3.org/2000/svg">
                <g fill="none" fill-rule="evenodd" stroke="#084185" stroke-linecap="round" stroke-width="2"
                   transform="translate(1 1)">
                    <circle cx="12.5" cy="12.5" r="12.5"/>
                    <path d="m6.25 12.5h12.5"/>
                    <path d="m12.5 18.75v-12.5"/>
                </g>
            </svg>
        </div>
        <div class="zoom__out" @click="zoomOutHandler">
            <svg height="27" viewBox="0 0 27 27" width="27" xmlns="http://www.w3.org/2000/svg">
                <g fill="none" fill-rule="evenodd" stroke="#084185" stroke-linecap="round" stroke-width="2"
                   transform="translate(1 1)">
                    <circle cx="12.5" cy="12.5" r="12.5"/>
                    <path d="m6.25 12.5h12.5"/>
                </g>
            </svg>
        </div>
    </div>
</template>

<script>
    export default {
        name:    "ZoomControls",
        props:   ['pc'],
        methods: {
            zoomInHandler: function () {
                this.$expiviReady.then(() => {
                    window.expivi.changeCameraZoom(10);
                })
            },

            zoomOutHandler: function () {
                this.$expiviReady.then(() => {
                    window.expivi.changeCameraZoom(-10);
                })
            }
        }
    }
</script>
